import React from 'react';
import { func, shape, bool, string } from 'prop-types';
import { Button, Tooltip } from '@ublend-npm/aulaui-next';
import AddIcon from '@material-ui/icons/Add';
import {
  SubTitle,
  ButtonTitle,
  buttonSize,
} from './DiscussionDetailsCard.styled';

export const AddDiscussionCard = ({
  openDiscussionTopicModal,
  discussionPermission,
}) => {
  const { allowed, message } = discussionPermission;
  const handleClick = () => {
    if (!allowed) {
      return;
    }
    openDiscussionTopicModal();
  };

  return (
    <>
      <SubTitle>Add discussion or activity</SubTitle>
      <Tooltip
        title={allowed ? 'Add discussion' : message}
        position="top"
        disabled={allowed}
      >
        <span>
          <Button
            type="secondary"
            onClick={handleClick}
            id="add-discussion"
            iconLeft={AddIcon}
            data-testid="add-discussion-button"
            aria-label="Add discussion"
            css={buttonSize}
            disabled={!allowed}
          >
            <ButtonTitle>Add discussion</ButtonTitle>
          </Button>
        </span>
      </Tooltip>
    </>
  );
};

AddDiscussionCard.propTypes = {
  openDiscussionTopicModal: func.isRequired,
  discussionPermission: shape({
    allowed: bool,
    message: string,
  }),
};

AddDiscussionCard.defaultProps = {
  discussionPermission: { allowed: true },
};

export default AddDiscussionCard;
